import { AnimatePresence, motion } from "motion/react";
import {
  CheckCircle,
  XCircle,
  Info,
  AlertTriangle,
  X,
} from "lucide-react";
import { useUIStore } from "../../stores/uiStore";
import { toastVariants } from "../../lib/animations";
import clsx from "clsx";

const iconMap = {
  success: CheckCircle,
  error: XCircle,
  info: Info,
  warning: AlertTriangle,
};

const colorMap = {
  success: {
    border: "border-l-lime-500",
    icon: "text-lime-500",
    glow: "shadow-[0_0_12px_rgba(132,204,22,0.15)]",
  },
  error: {
    border: "border-l-rose-500",
    icon: "text-rose-500",
    glow: "shadow-[0_0_12px_rgba(244,63,94,0.15)]",
  },
  info: {
    border: "border-l-lime-400",
    icon: "text-lime-400",
    glow: "shadow-[0_0_12px_rgba(163,230,53,0.12)]",
  },
  warning: {
    border: "border-l-amber-500",
    icon: "text-amber-500",
    glow: "shadow-[0_0_12px_rgba(245,158,11,0.15)]",
  },
};

export default function ToastContainer() {
  const { toasts, removeToast } = useUIStore();

  return (
    <div className="fixed top-4 right-4 z-[9999] flex flex-col gap-2.5 pointer-events-none">
      <AnimatePresence mode="popLayout">
        {toasts.map((toast) => {
          const Icon = iconMap[toast.type];
          const colors = colorMap[toast.type];

          return (
            <motion.div
              key={toast.id}
              variants={toastVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              layout
              className={clsx(
                "pointer-events-auto",
                "rounded-xl px-4 py-3 min-w-[280px] max-w-[400px]",
                "bg-white/80 dark:bg-[#0d1420]/85",
                "backdrop-blur-2xl",
                "border border-white/50 dark:border-lime-500/10",
                "flex items-start gap-3",
                "border-l-4",
                colors.border,
                colors.glow
              )}
            >
              <Icon className={clsx("w-5 h-5 flex-shrink-0 mt-0.5", colors.icon)} />
              <span className="text-sm text-[var(--text-primary)] flex-1">
                {toast.message}
              </span>
              <button
                onClick={() => removeToast(toast.id)}
                className="text-[var(--text-tertiary)] hover:text-[var(--text-primary)] transition-colors p-0.5 rounded hover:bg-black/5 dark:hover:bg-white/5"
              >
                <X size={16} />
              </button>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}
